import React, { useContext, useState } from 'react'
import { ASVCon, AvailSection } from '../styles'
import { PlayersOnTeam } from '../../../Api'
import { PlayerList } from './AvailPlayers/PlayerList'
import { AllStarContext } from '../../../Context'
import { TabPanel } from '../../../Components/Tab/TabPanel'
import { SelectedPlayers } from './Selected/SelectedPlayers'
import { Spinner } from '../../../Components/Icons'
import { colors } from '../../../Components/consts'
import { Con } from '../../../Components/Layout/Containers/ConStyles'
import { TabHeaderStyle } from '../../../Components/Tab/styles'
import { asgTeams } from '../../../Constants/allStar'
import { ASG_POSITION_TABS } from '../../../Constants/allStar'
import { Tab } from '../../../Components/LazyComponents'

export const AllStarContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { loading, selectedPlayers, closed, notStarted, playerType } =
    useContext(AllStarContext)!
  const [value, setValue] = useState<number>(0)

  const isSelected = (player: PlayersOnTeam) => {
    let isPlayerSelected = selectedPlayers.find(
      (p) => p.officialId === player.officialId
    )
    return isPlayerSelected ? true : false
  }

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    event.preventDefault()
    setValue(newValue)
  }

  const renderSpinner = () => {
    return (
      <Con justify="center">
        <div>
          <Spinner fill={colors.yellow} />
          Loading...
        </div>
      </Con>
    )
  }

  if (closed || notStarted) {
    return (
      <ASVCon playertype={playerType}>
        <SelectedPlayers tabs={asgTeams} />
        <AvailSection>
          <div className="availablePlayersCon">
            {closed && (
              <h3>All star voting is closed. Stay tuned for the roster release!</h3>
            )}
            {notStarted && <h3>All star voting has not started yet.</h3>}
          </div>
        </AvailSection>
      </ASVCon>
    )
  }

  return (
    <ASVCon playertype={playerType}>
      <SelectedPlayers tabs={asgTeams} />
      <TabHeaderStyle
        tabColor={'dark'}
        noBackground
        fullwidth
        topRadius={0}
        indicolor={colors.white}
        value={value}
        onChange={handleChange}
        aria-label="asg tabs"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        selectedColor={colors.white}
        scrollButtonColor={colors.white}
      >
        {ASG_POSITION_TABS.map((t) => (
          <Tab label={t} key={t} />
        ))}
      </TabHeaderStyle>
      {ASG_POSITION_TABS.map((t, idx) => (
        <TabPanel key={idx} value={value} index={idx}>
          {!loading && <PlayerList position={t} isSelected={isSelected} />}
          {loading && renderSpinner()}
        </TabPanel>
      ))}
    </ASVCon>
  )
}
